import { render, staticRenderFns } from "./RecentGlosses.vue?vue&type=template&id=329cc868&scoped=true"
import script from "./RecentGlosses.vue?vue&type=script&lang=ts"
export * from "./RecentGlosses.vue?vue&type=script&lang=ts"
import style0 from "./RecentGlosses.vue?vue&type=style&index=0&id=329cc868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329cc868",
  null
  
)

export default component.exports